import { c } from 'react-compiler-runtime';
import { AlertIcon, GitMergeQueueIcon, IssueDraftIcon, GitPullRequestDraftIcon, GitMergeIcon, GitPullRequestClosedIcon, SkipIcon, IssueClosedIcon, GitPullRequestIcon, IssueOpenedIcon } from '@primer/octicons-react';
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import classes from './StateLabel.module.css.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Octicon from '../Octicon/Octicon.js';

const octiconMap = {
  issueOpened: IssueOpenedIcon,
  pullOpened: GitPullRequestIcon,
  issueClosed: IssueClosedIcon,
  issueClosedNotPlanned: SkipIcon,
  pullClosed: GitPullRequestClosedIcon,
  pullMerged: GitMergeIcon,
  draft: GitPullRequestDraftIcon,
  issueDraft: IssueDraftIcon,
  pullQueued: GitMergeQueueIcon,
  unavailable: AlertIcon,
  open: null,
  closed: null
};
const labelMap = {
  issueOpened: 'Issue',
  pullOpened: 'Pull request',
  issueClosed: 'Issue',
  issueClosedNotPlanned: 'Issue, not planned',
  pullClosed: 'Pull request',
  pullMerged: 'Pull request',
  draft: 'Pull request',
  issueDraft: 'Issue',
  pullQueued: 'Pull request',
  unavailable: '',
  open: '',
  closed: ''
};
const StateLabel = /*#__PURE__*/forwardRef((t0, ref) => {
  const $ = c(22);
  let children;
  let className;
  let rest;
  let status;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      status,
      variant: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = status;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    status = $[4];
    t1 = $[5];
  }
  const variantProp = t1 === undefined ? "normal" : t1;
  let t2;
  if ($[6] !== variantProp) {
    t2 = variantProp === "small" ? {
      width: "1em"
    } : {};
    $[6] = variantProp;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const octiconProps = t2;
  const noIconStatus = status === "open" || status === "closed";
  let t3;
  if ($[8] !== className) {
    t3 = clsx(classes.StateLabel, className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== noIconStatus || $[11] !== octiconProps || $[12] !== status) {
    t4 = !noIconStatus && /*#__PURE__*/jsx(Octicon, {
      ...octiconProps,
      icon: octiconMap[status],
      "aria-label": labelMap[status],
      className: classes.Icon
    });
    $[10] = noIconStatus;
    $[11] = octiconProps;
    $[12] = status;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== children || $[15] !== ref || $[16] !== rest || $[17] !== status || $[18] !== t3 || $[19] !== t4 || $[20] !== variantProp) {
    t5 = /*#__PURE__*/jsxs("span", {
      ...rest,
      ref: ref,
      className: t3,
      "data-variant": variantProp,
      "data-status": status,
      children: [t4, children]
    });
    $[14] = children;
    $[15] = ref;
    $[16] = rest;
    $[17] = status;
    $[18] = t3;
    $[19] = t4;
    $[20] = variantProp;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
});
StateLabel.displayName = 'StateLabel';

export { StateLabel as default };
